/**
 * SAM-944: the time of day a pass starts at, for its phone card; null when it is a whole-day pass (midnight, in
 * UTC or in the tenant's clock), which the card calls «All day».
 */
export const passClock = (iso: string | null | undefined, time: (v: string) => string): string | null => {
  if (!iso || /^\d{4}-\d{2}-\d{2}$/.test(iso)) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  const midnightUtc = d.getUTCHours() === 0 && d.getUTCMinutes() === 0;
  const sd = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Santo_Domingo', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' }).formatToParts(d);
  const midnightSd = sd.find((x) => x.type === 'hour')?.value === '00' && sd.find((x) => x.type === 'minute')?.value === '00';
  return midnightUtc || midnightSd ? null : time(iso);
};
